import {CircularProgress} from '@mui/material';
import {usePortalAccess} from '../../shared/auth/PortalAccessContext';
import {PortalShell} from '../../shared/ui';
import SemAcessoPage from '../../features/Shared/SemAcessoPage';

/** Abre a área só para quem tem a visão dela (BBF-175); sem a visão, um aviso no lugar da página. */
export function VisaoRoute({visao, children}) {
    const {carregando, erro, podeVer} = usePortalAccess();

    if (carregando) {
        return (
            <PortalShell>
                <div className="bf-empty"><CircularProgress /></div>
            </PortalShell>
        );
    }

    if (!podeVer(visao)) {
        return <SemAcessoPage erro={erro} />;
    }

    return children;
}
